export default __webpack_public_path__ + "static/media/tuikuan.91804009.png";